export var institutionUserUrl :Array<String> =[
      "",
      "dashboard",
      "changePassword",
      "elearning",
      "elearning/manage",
      "elearning/puzzles",
      "elearning/puzzles/start/:id",
      "activate",
      "sopObserve",
      "newObserve",
      "sopObserve/newObserve",
      "observeProtocol",
      "sopObserve/observeProtocol",
      "observeObservationProtocol",
      "observe/observeObservationProtocol",
      "evaluation",
      "evaluation/observeSOP/processCompliance",
      "evaluation/observeSOP/frequencyDistribution",
      "evaluation/observeSOP/subStepCompliance",
      "evaluation/observeSOP/sopComments",
      "evaluation/observeSOP/sopIndividualOverview",
      "evaluation/observeSOP/reportSop",
      "observeObservation/statistical",
      "evaluation/observe/overallCompliance",
      "evaluation/observe/fivemoments",
      "evaluation/observe/quota",
      "evaluation/observe/StatisticsBeforeAsepticProcedures",
      "evaluation/observe/individualOverview",
      "evaluation/observe/comments",
      "evaluation/hygiene-check/statistical",
      "evaluation/hygiene-check/quickComments",
      "evaluation/hygiene-check/complianceQuestions",
      "evaluation/hygiene-check/overallCompliance",
      "evaluation/hygiene-check/individualData",
      "reportSop",
      "evaluation/observeSOP/statistical",
      "statistical",
      "evaluation/consumption",
      "consumption",
      "new",
      "new/start/:period/:Id",
      "new/start/:Id",
      "past",
      "newquota",
      "editquota/:quotaID",
      'profile',
      'hygiene-check',
      'new-hygiene-check',
      'hygiene-check-editor',
      'questionnaire-editor/:id',
      'questionnaire-viewer/:id',
      "consumption/statistical",
      "evaluation/consumption/totalConsumption",
      "evaluation/consumption/consumptionPerPatient",
      "edit/:id",
      "view/:id"
    ]

